/**
 * Redux actions for Contact Search
 */

// Action types
export const CONTACT_SEARCH_SET_STATUS = 'CONTACT_SEARCH_SET_STATUS'
export const CONTACT_SEARCH_SET_RESULTS = 'CONTACT_SEARCH_SET_RESULTS'
export const CONTACT_SEARCH_SET_FIRST = 'CONTACT_SEARCH_SET_FIRST'
export const CONTACT_SEARCH_SET_ROWS = 'CONTACT_SEARCH_SET_ROWS'
export const CONTACT_SEARCH_SET_CURRENT_PAGE = 'CONTACT_SEARCH_SET_CURRENT_PAGE'
export const CONTACT_SEARCH_SET_TOTAL_PAGES = 'CONTACT_SEARCH_SET_TOTAL_PAGES'
export const CONTACT_SEARCH_SET_FILTER = 'CONTACT_SEARCH_SET_FILTER'
export const CONTACT_SEARCH_SET_SORT = 'CONTACT_SEARCH_SET_SORT'
export const CONTACT_SEARCH_SET_SEARCH_TERM = 'CONTACT_SEARCH_SET_SEARCH_TERM'
export const CONTACT_SEARCH_RESET = 'CONTACT_SEARCH_RESET'

// Action creators
export const setContactSearchStatusAction = (status) => ({
    type: CONTACT_SEARCH_SET_STATUS,
    payload: status
})

export const setContactSearchResultsAction = (results, totalCount) => ({
    type: CONTACT_SEARCH_SET_RESULTS,
    payload: { results, totalCount }
})

export const setContactSearchFirstAction = (first) => ({
    type: CONTACT_SEARCH_SET_FIRST,
    payload: first
})

export const setContactSearchRowsAction = (rows) => ({
    type: CONTACT_SEARCH_SET_ROWS,
    payload: rows
})

export const setContactSearchCurrentPageAction = (page) => ({
    type: CONTACT_SEARCH_SET_CURRENT_PAGE,
    payload: page
})

export const setContactSearchTotalPagesAction = (pages) => ({
    type: CONTACT_SEARCH_SET_TOTAL_PAGES,
    payload: pages
})

export const setContactSearchFilterAction = (filter) => ({
    type: CONTACT_SEARCH_SET_FILTER,
    payload: filter
})

export const setContactSearchSortAction = (sort) => ({
    type: CONTACT_SEARCH_SET_SORT,
    payload: sort
})

export const setContactSearchTermAction = (term) => ({
    type: CONTACT_SEARCH_SET_SEARCH_TERM,
    payload: term
})

export const resetContactSearchAction = () => ({
    type: CONTACT_SEARCH_RESET
})

// Contact Works Action Types
export const CONTACT_SEARCH_WORKS_SET_FETCH_STATUS = 'CONTACT_SEARCH_WORKS_SET_FETCH_STATUS'
export const CONTACT_SEARCH_WORKS_SET_FETCH_RESULTS = 'CONTACT_SEARCH_WORKS_SET_FETCH_RESULTS'
export const CONTACT_SEARCH_WORKS_SET_CURRENT_PAGE = 'CONTACT_SEARCH_WORKS_SET_CURRENT_PAGE'
export const CONTACT_SEARCH_WORKS_SET_TOTAL_PAGES = 'CONTACT_SEARCH_WORKS_SET_TOTAL_PAGES'
export const CONTACT_SEARCH_WORKS_SET_ROWS = 'CONTACT_SEARCH_WORKS_SET_ROWS'
export const CONTACT_SEARCH_WORKS_SET_FIRST = 'CONTACT_SEARCH_WORKS_SET_FIRST'
export const CONTACT_SEARCH_WORKS_SET_FILTER = 'CONTACT_SEARCH_WORKS_SET_FILTER'
export const CONTACT_SEARCH_WORKS_SET_SORT = 'CONTACT_SEARCH_WORKS_SET_SORT'
export const CONTACT_SEARCH_WORKS_INIT = 'CONTACT_SEARCH_WORKS_INIT'

// Contact Works Action Creators
export const setContactSearchWorksFetchStatusAction = (contactId, status) => ({
    type: CONTACT_SEARCH_WORKS_SET_FETCH_STATUS,
    payload: { contactId, status }
})

export const setContactSearchWorksFetchResultsAction = (contactId, results) => ({
    type: CONTACT_SEARCH_WORKS_SET_FETCH_RESULTS,
    payload: { contactId, results }
})

export const setContactSearchWorksCurrentPageAction = (contactId, currentPage) => ({
    type: CONTACT_SEARCH_WORKS_SET_CURRENT_PAGE,
    payload: { contactId, currentPage }
})

export const setContactSearchWorksTotalPagesAction = (contactId, totalPages) => ({
    type: CONTACT_SEARCH_WORKS_SET_TOTAL_PAGES,
    payload: { contactId, totalPages }
})

export const setContactSearchWorksRowsAction = (contactId, row) => ({
    type: CONTACT_SEARCH_WORKS_SET_ROWS,
    payload: { contactId, row }
})

export const setContactSearchWorksFirstAction = (contactId, first) => ({
    type: CONTACT_SEARCH_WORKS_SET_FIRST,
    payload: { contactId, first }
})

export const setContactSearchWorksFilterAction = (contactId, filter) => ({
    type: CONTACT_SEARCH_WORKS_SET_FILTER,
    payload: { contactId, filter }
})

export const setContactSearchWorksSortAction = (contactId, sort) => ({
    type: CONTACT_SEARCH_WORKS_SET_SORT,
    payload: { contactId, sort }
})

export const initContactSearchWorksAction = (contactId) => ({
    type: CONTACT_SEARCH_WORKS_INIT,
    payload: { contactId }
})

// Add Potential Member Action Types
export const ADD_POTENTIAL_MEMBER_SET_FIELD = 'ADD_POTENTIAL_MEMBER_SET_FIELD'
export const ADD_POTENTIAL_MEMBER_SET_ERRORS = 'ADD_POTENTIAL_MEMBER_SET_ERRORS'
export const ADD_POTENTIAL_MEMBER_SET_STATUS = 'ADD_POTENTIAL_MEMBER_SET_STATUS'
export const ADD_POTENTIAL_MEMBER_RESET = 'ADD_POTENTIAL_MEMBER_RESET'

// Add Potential Member Action Creators
export const setAddPotentialMemberFieldAction = (field, value) => ({
    type: ADD_POTENTIAL_MEMBER_SET_FIELD,
    payload: { field, value }
})

export const setAddPotentialMemberErrorsAction = (errors) => ({
    type: ADD_POTENTIAL_MEMBER_SET_ERRORS,
    payload: errors
})

export const setAddPotentialMemberStatusAction = (status) => ({
    type: ADD_POTENTIAL_MEMBER_SET_STATUS,
    payload: status
})

export const resetAddPotentialMemberAction = () => ({
    type: ADD_POTENTIAL_MEMBER_RESET
})
